import PropTypes from 'prop-types';

const RadioGroup = ({
  groupLabel,
  options = [],
  value,
  onChange,
  inline = false,
  labelPosition = 'right',
  groupLabelClassName = '',
  radioContainerClassName = '',
  radioLabelClassName = '',
  radioInputClassName = '',
  containerStyles = null,
  disabled = false,
}) => {

  const handleRadioChange = (event) => {
    if (disabled) return;
    
    const { value: radioValue } = event.target;
    
    // Assuming option.value can be numbers or strings, ensure consistency
    const isNumeric = options.some(opt => typeof opt?.value === 'number' || typeof opt?.label === 'number' || typeof opt === 'number');
    const newValue = isNumeric ? Number(radioValue) : radioValue;
    onChange(newValue);
  };

  const containerStyle = containerStyles || (inline ? { display: 'flex', gap: '1rem', flexWrap: 'wrap' } : {});
  const itemStyle = inline ? {} : { display: 'block', marginBottom: '0.5rem' };

  return (
    <div className="radio-group-container">
      {groupLabel && groupLabel !== 'tripadvisorCategory' && <label className={`radio-group-label ${groupLabelClassName}`}>{groupLabel}</label>}
      <div style={containerStyle}>
        {options.map((option) => {
          const optionValue = option?.value ?? option?.label ?? option;
          const optionLabel = option?.label ?? option;
          const isChecked = value === optionValue;
          const radioId = `radio-${groupLabel}-${optionValue}`;

          return (
            <div
              key={optionValue}
              className={`radio-item-container ${radioContainerClassName}`}
              style={itemStyle}
            >
              {labelPosition === 'left' && (
                <label 
                  htmlFor={radioId} 
                  className={`radio-label ${radioLabelClassName}`}
                  style={{ opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
                >
                  {optionLabel}
                </label>
              )}
              <input
                type="radio"
                id={radioId}
                name={groupLabel}
                value={optionValue}
                checked={isChecked}
                onChange={handleRadioChange}
                disabled={disabled}
                className={`radio-input ${radioInputClassName}`}
                style={labelPosition === 'left' ? { marginLeft: '0.5rem' } : { marginRight: '0.5rem' }}
              />
              {labelPosition === 'right' && (
                <label 
                  htmlFor={radioId} 
                  className={`radio-label ${radioLabelClassName}`}
                  style={{ opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
                >
                  {optionLabel}
                </label>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

RadioGroup.propTypes = {
  groupLabel: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  inline: PropTypes.bool,
  labelPosition: PropTypes.oneOf(['left', 'right']),
  groupLabelClassName: PropTypes.string,
  radioContainerClassName: PropTypes.string,
  radioLabelClassName: PropTypes.string,
  radioInputClassName: PropTypes.string,
  containerStyles: PropTypes.object,
};

export default RadioGroup;
